import React from "react";

export class Grid3 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <>
        {this.props.children ? (
          !this.props.children.length ? (
            <>
              <div className={`row ${this.props.parentClass} mb-3`}>
                <div className={`col-md-4 ${this.props.classNames}`}>
                  {this.props.children}
                </div>
              </div>
            </>
          ) : (
            this.props.children.map((Component, index) => {
              if (index === 0 || index % 3 === 0)
                return (
                  <div key={`itsadfsdfadfem-${index}`} className={`row ${this.props.parentClass}`}>
                    {!Component ? (
                      <> </>
                    ) : (
                      <div className={`col-md-4 ${this.props.classNames}`}>
                        {Component}
                      </div>
                    )}
                    {!this.props.children[index + 1] ? (
                      <> </>
                    ) : (
                      <div className={`col-md-4 ${this.props.classNames}`}>
                        {this.props.children[index + 1]}
                      </div>
                    )}
                    {!this.props.children[index + 2] ? (
                      <> </>
                    ) : (
                      <div className={`col-md-4 ${this.props.classNames}`}>
                        {this.props.children[index + 2]}
                      </div>
                    )}
                  </div>
                );
              else return <React.Fragment key={`ashdfas-${index}`} />;
            })
          )
        ) : (
          <> </>
        )}
      </>
    );
  }
}

export default Grid3;
